import { PaginatedDataSheetBusinessEstimates } from '@lune-fe/dapi-models'
import { CategoryChip, formatToCurrency } from '@lune-fe/lune-components-lib'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { FC, RefObject } from 'react'

import { formatNumberWithFallback } from 'utils'
import {
    DataSheetEstimateContextMenu,
    EmissionCalculationRow,
    EstimateTypeName,
    EstimateTypeSlug,
} from 'views/CalculateEmissions'

// Extract the individual business estimate type from the paginated response
type DataSheetBusinessEstimate = PaginatedDataSheetBusinessEstimates['data'][0]

const DataSheetBusinessRow: FC<{
    calculation: DataSheetBusinessEstimate
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
}> = ({ calculation, currentPage, queryParams, pageHistoryRef }) => {
    const estimateType = calculation.estimateType
    const slug = EstimateTypeSlug(estimateType)

    return (
        <EmissionCalculationRow
            id={calculation.id}
            slug={slug}
            emissionType={EstimateTypeName(estimateType)}
            estimateType={estimateType}
            contextMenu={<DataSheetEstimateContextMenu quantity={calculation.quantity} />}
            currentPage={currentPage}
            pageHistoryRef={pageHistoryRef}
            queryParams={queryParams}
        >
            <TableNew.TableCell colSize={4} oneLineText>
                {calculation.name || 'Transaction'}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={3}>
                <CategoryChip sx={{ maxWidth: '200px' }} category={calculation.category} />
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {calculation.accountName}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1}>
                {calculation.value?.value
                    ? formatToCurrency(calculation.value.value, calculation.value.currency)
                    : '--'}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1}>
                {formatNumberWithFallback(calculation.quantity, {
                    decimals: 2,
                    decimalsWhenLessThan: 6,
                    fallback: '--',
                })}
            </TableNew.TableCell>
        </EmissionCalculationRow>
    )
}

export default DataSheetBusinessRow
